import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Observable, tap, withLatestFrom } from 'rxjs';
import { ROUTE_IS_HOME } from './icilalune-router.tokens';
import { WINDOW } from '@ng-web-apis/common';

@Injectable()
export class RouterEffects {
  isNotHome$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        withLatestFrom(this.isHome$),
        tap(([action, isHome]) => {
          if (!isHome) {
            this.window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        })
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    @Inject(WINDOW) private window: Window,
    @Inject(ROUTE_IS_HOME) private isHome$: Observable<boolean>
  ) {}
}
